import { render } from "./EditTutarialCates.vue?vue&type=template&id=09225203&scoped=true"
import script from "./EditTutarialCates.vue?vue&type=script&lang=js"
export * from "./EditTutarialCates.vue?vue&type=script&lang=js"

import "./EditTutarialCates.vue?vue&type=style&index=0&id=09225203&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09225203"]])

export default __exports__